import InternalUser from './routes/internal-user/InternalUser.vue';
import addInternalUser from './routes/internal-user/component/addUser.vue';
import editInternalUser from './routes/internal-user/component/editUser.vue';
import editInternalUserPassword from './routes/internal-user/component/editUserPassword.vue';

const superAdminRoutes = [
  {
    path: '/internal-user',
    name: 'InternalUser',
    component: InternalUser,
  },
  {
    path: '/add-internal-user',
    name: 'addInternalUser',
    component: addInternalUser,
  },
  {
    path: '/edit-internal-user/:id',
    name: 'editInternalUser',
    component: editInternalUser,
  },
  {
    path: '/edit-internal-user-password/:id',
    name: 'editInternalUserPassword',
    component: editInternalUserPassword,
  },

];

export default superAdminRoutes;
